import axios from "fetch-api/fetch-api";
import { getPageDetails } from "util/url/apiConstants";
import { IAllMakes } from "../interfaces/garage-apis";

export function getMakes() {
  return axios.get<IAllMakes>(`${getPageDetails}`, {
    params: {
      url: "all-makes",
    },
  });
}
